






























































































































































































import { Component, Vue } from 'vue-property-decorator'

import { TextFieldRules } from '@/utils/enums'
import authModule from '@/store/auth'
import userModule from '@/store/user'
import UserEditor from '@/components/user/UserEditor.vue'

@Component({
  name: 'Settings',
  components: {
    UserEditor
  }
})
class Settings extends Vue {
  private rules = TextFieldRules
  private inviteEmail = ''

  private logout(): void {
    authModule.logout()
    this.$router.push({ name: 'Login' })
  }

  private sendInvite(): void {
    userModule.invite(this.inviteEmail)
  }
}
export default Settings
